"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeItem2LabelInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _zeroStyled = require("../internals/zero-styled");
/**
 * @ignore - internal component.
 */
const TreeItem2LabelInput = exports.TreeItem2LabelInput = (0, _zeroStyled.styled)('input', {
  name: 'MuiTreeItem2',
  slot: 'LabelInput',
  overridesResolver: (props, styles) => styles.labelInput
})(({
  theme
}) => (0, _extends2.default)({}, theme.typography.body1, {
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  border: 'none',
  padding: '0 2px',
  boxSizing: 'border-box',
  '&:focus': {
    outline: `1px solid ${theme.palette.primary.main}`
  }
}));